import { Directive, TemplateRef } from "@angular/core";

@Directive({
    selector: '[dialogTitle]',
})
export class DialogTitleDirective {
    constructor(public tpl: TemplateRef<any>) { }
}